export const EDIT_ROLE_ID = 'edit-role';
export const DUPLICATE_ROLE_ID = 'duplicate-role';
export const DEACTIVATE_ROLE_ID = 'deactivate-role';

export const EDIT_ROLE_LABEL = 'Edit Role';

export const NO_ROLE_DESCRIPTION = 'No role description available.';
export const NO_ROLES = 'No roles have been created.';
export const NO_ROLE_MEMBERS = 'No users have been added to this role.';

export const SPECIFIC_GROUPS = 'specific_groups';
export const SPECIFIC_TEAMS = 'specific_teams';
export const SELF = 'self';
export const DEFAULT_PRODUCT_AREA_LABEL = 'default';
export const EXPAND_ALL = 'Expand All';
export const COLLAPSE_ALL = 'Collapse All';
export const DATA_ACCESS_POLICY_VISIBLE_LABEL = 'Data Visible:';
export const USERS_TAB_PERMISSIONS_CODES = [
  'manage_users',
  'view_users',
  'administer_passwords',
  'approve_pending_profiles',
];
export const EXCLUDE_DATA_ACCESS_POLICIES_BY_PRODUCT_AREA_OBJ = {
  social: [SELF],
  [DEFAULT_PRODUCT_AREA_LABEL]: [SPECIFIC_GROUPS],
};
export const SPECIFIC_GROUPS_INVALID_MESSAGE_HEADER =
  'The following Product Areas have Specific Groups scope, but no groups have been selected.';
export const DATA_SCOPE_ERROR_MESSAGE_HEADER = `The Product Area Data Scope selected cannot be greater than the Default Data Scope configured for the role.
Please update the following Product Areas Scope to be less than or equal to the Default Data Scope.`;
export const DATA_SCOPE_SPECIFIC_GROUPS_ERROR_MESSAGE_LABEL =
  'Specific Groups missing';
export const DATA_SCOPE_INVALID_ERROR_MESSAGE_LABEL =
  'Invalid Data Scope selected';
export const APPLEALS_DATA_SCOPE_ERROR_MESSAGE_HEADER =
  'The Appeals Area Data Scope selected cannot be greater than the QA Data Scope configured for the role.';
